import { FC, SVGAttributes } from "react";

const Tag: FC<SVGAttributes<SVGSVGElement>> = ({ width = 24, height = 24 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.5 4C2.5 2.89543 3.39543 2 4.5 2H12.2574C12.7878 2 13.2965 2.21071 13.6716 2.58579L22.6716 11.5858C23.4526 12.3668 23.4526 13.6332 22.6716 14.4142L14.9142 22.1716C14.1332 22.9526 12.8668 22.9526 12.0858 22.1716L3.08579 13.1716C2.71071 12.7965 2.5 12.2878 2.5 11.7574V4Z"
      strokeWidth="2"
    />
    <circle cx="7" cy="6.5" r="1.5" fill="#fff" />
  </svg>
);

export { Tag };
